<!-- Screenname:Generic Master Creation
Developer Name:Bharanidharan.
Created date on:1/02/2023
Last Working date on:23/03/2023
Comments and Suggestions:
TS File:GenericMasterService -->

<template>
  <Dialog
    v-model:visible="showDialog"
    :modal="true"
    :header="model ? $t('GenericMaster.Edittitle') : $t('GenericMaster.title')"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col lg="6" md="6" sm="6" cols="12">
          <div class="field">
            <TextField
              v-model="genericform.GenericCode"
              placeholder=" "
              :requiredIcon="true"
              clearable
              name="id"
              id="id"
              :label="$t('GenericMaster.id')"
              :rules="{ required: true }"
              disabled
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="8" md="6" sm="6" cols="12">
          <div class="field">
            <TextField
              v-model="genericform.GenericName"
              :requiredIcon="true"
              placeholder=" "
              name="Name"
              id="Name"
              :label="$t('GenericMaster.name')"
              :rules="{ required: true }"
              :autofocus="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="8" md="12" sm="12" cols="12">
          <div class="field">
            <Textarea
              v-model="genericform.Remarks"
              :requiredIcon="false"
              placeholder=" "
              name="Description"
              id="Description"
              :label="$t('GenericMaster.description')"
              :rules="{ required: false }"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <Footer
            @cancel="(showDialog = false), IsClear()"
            :cancelhide="false"
            :label="label"
            :loading="Saveloading"
          />
        </b-col>
      </b-row>
    </b-form>
  </Dialog>
  <createdsuccessfully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import GenericService from "../../../../Service/GenericMasterService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import Textarea from "../../../../../../components/FormComponents/TextArea.vue";
import AddButton from "../../../../../../components/GeneralButtons/AddButton.vue";
import createdsuccessfully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import common from "../../../../Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import moment from "moment";

export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Footer,
    TextField,
    Textarea,
    createdsuccessfully,
    UpdatedSuccessfully,
    AlreadyExist,
  },
  setup(props, { emit }) {
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    // let Entitydata = ref();
    // Entitydata.value = localStorage.getItem("EntityData");
    // Entitydata.value = JSON.parse(Entitydata.value);
    let Entitydata = ref({
      EntityId: 0,
    });
    Entitydata.value.EntityId = props.EntityId;
    const showDialog = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    debugger;
    const model: any = ref(props.selectedItem);
    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }
    const successpop = ref(false);
    const Editmodel = ref(false);
    const updatepop = ref(false);
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const alreadyexistpop = ref(false);
    let Saveloading = ref(false);
    //Loader...
    const genericform = ref({
      Id: 0,
      GenericName: "",
      GenericCode: "",
      Remarks: "",
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedBy: 0,
      ModifiedAt: "",
      HospitalId: 0,
      BranchId: 0,
      EntityId: 0,
      EntityOperationId: 0,
    });
    const copydataModel = JSON.parse(JSON.stringify(genericform.value));

    //Add-New Button-Open Popup
    function IsCreate() {
      showDialog.value = true;
      GetCode();
    }

    //AutoGenerate Code Template for Generic Code
    async function GetCode() {
      debugger;
      let data = {
        //FormId: 9,
        EntityId: Entitydata.value.EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      genericform.value.GenericCode = result;
    }

    //Save
    const IsSubmit = async () => {
      debugger;
      Saveloading.value = true;
      emit("loadershow");

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }

      try {
        let result: any;
        let msg = "";
        genericform.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        genericform.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        genericform.value.BranchId = 0;
        genericform.value.HospitalId = HospitalId;
        genericform.value.ModifiedBy = UserId;
        genericform.value.CreatedBy = UserId;
        genericform.value.EntityId = Number(Entitydata.value.EntityId);

        if (genericform.value.Id != 0) {
          //IsSubmit Function for Edit(Update) Method

          genericform.value.EntityOperationId = props.OperationID.UpdateId;
          const result = await GenericService.updatedata(genericform.value);
          msg = result["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (result["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            updatepop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        } else {
          //IsSubmit Function for Create Method
          genericform.value.EntityOperationId = props.OperationID.CreateId;
          const result = await GenericService.createdata(genericform.value);
          msg = result["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (result["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            successpop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        }
      } catch (error) {
        Saveloading.value = false;
        emit("loaderhide");
        console.log(error);
      }
    };

    //Get Value from Table and show in Popup
    async function IsEdit() {
      showDialog.value = true;
      emit("loadershow");
      try {
        debugger;
        label.value = t("btn.update");
        let Id = model.value.Id;
        let response = await GenericService.getdata(Id);
        let datas = response["result"];
        Object.keys(genericform.value).forEach((key) => {
          if (datas[key]) genericform.value[key] = datas[key];
        });
        Editmodel.value = false;
        emit("loaderhide");
      } catch (error) {
        emit("loaderhide");
        console.log(error);
      }
    }
    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });
    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false &&
          alreadyexistpop.value == false)
      ) {
        IsClear();
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }
    //Popup-Close
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      emit("load");
      IsClear();
    }
    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      genericform.value.GenericName = "";
      //showDialog.value = true
    }
    //Clear Values while clicking Add New Button
    const IsClear = () => {
      Object.assign(genericform.value, copydataModel);
      showDialog.value = false;
      emit("update:selectedItem", undefined);
      emit("close");
    };

    return {
      Saveloading,
      model,
      successpop,
      genericform,
      IsClear,
      IsEdit,
      IsCreate,
      showDialog,
      Editmodel,
      closetrigger,
      errors,
      IsSubmit,
      updatepop,
      alreadyclosetrigger,
      alreadyexistpop,
      label,
    };
  },
});
</script>
